import { render } from "./MenuProvider.vue?vue&type=template&id=0fdde1be"
import script from "./MenuProvider.vue?vue&type=script&lang=js"
export * from "./MenuProvider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__